import { gameDrawer } from '../../services/gameDrawer';
import { gameService } from '../../services/gameService';

import { gameStore } from '../../store/gameStore';
import { winBarStore } from '../../store/winBarStore';
import { bettingPartStore } from '../../store/bettingPartStore';

import { isMobile } from '../helpers/isMobile';
import { generateTweenData, startTweenData } from '../helpers/tween';
import { mousePositionToIconColumnRow } from '../helpers/mousePositionToIconICoordinates';
import { applicationStore } from '../../store/applicationStore';

let lastY;
let touchY;
let target;
let secondTarget;
let columns;
let touchMoving;
let moveDistance;
let returnControl;
let pressedColumn;
let returningToThePlace;

function stopReturn() {
  if (returnControl) {
    returnControl.stop();
    returnControl = null;
  }
}

function reset() {
  target.cursor = 'grab';
  secondTarget.cursor = 'grab';
  pressedColumn = -1;
  touchMoving = false;
  moveDistance = 0;
}

function onTouchStart(event) {
  if (event.data.buttons !== 1 && returningToThePlace) return;
  if (returningToThePlace) {
    return;
  }
  const iconCoordinates = mousePositionToIconColumnRow(target, event);
  if (iconCoordinates) {
    if (gameStore.isSpinStart || bettingPartStore.isAutoBetStart) {
      stopReturn();
      gameDrawer.forceStopAnimation();
      reset();
      return;
    }

    if (winBarStore.winAmount && !gameStore.isSpinStart) {
      gameDrawer.forceStopAnimation();
      if (!applicationStore.isSkipSpinAfterBetChange) {
        gameService.doSpin();
      }
    }
    if (!gameStore.isSpinStart && !returningToThePlace) {
      stopReturn();
      pressedColumn = iconCoordinates.column;
      target.cursor = 'grabbing';
      moveDistance = 0;
      touchMoving = true;
      lastY = event.data.global.y;
      touchY = event.data.global.y;
    }
  }
}

function returnToThePlace(forceReturn, onComplete) {
  if (returningToThePlace) {
    return;
  }
  returningToThePlace = true;
  touchMoving = false;
  target.cursor = 'grab';

  function onF() {
    returningToThePlace = false;
    reset();
    if (onComplete) onComplete();
  }

  if ((!gameStore.isSpinStart || forceReturn) && moveDistance !== 0) {
    const data = generateTweenData(moveDistance, 0, 100);

    returnControl = startTweenData(
      null,
      data,
      (t, v) => {
        if (pressedColumn === -1) {
          stopReturn();
          onF();
        } else {
          columns[pressedColumn].move(v - moveDistance);
          moveDistance = v;
        }
      },
      onF,
    );
  } else onF();
}

function onPointerMove(event) {
  if (
    event.data.buttons !== 1 ||
    pressedColumn === -1 ||
    !touchMoving ||
    returningToThePlace ||
    gameStore.isSpinStart || applicationStore.isSkipSpinAfterBetChange
  )
    return;
  const iconCoordinates = mousePositionToIconColumnRow(target, event);
  if (!iconCoordinates || iconCoordinates.column !== pressedColumn) {
    returnToThePlace();
  } else {
    moveDistance = (event.data.global.y - touchY) / target.worldTransform.d;
    const passedDistance = Math.abs(moveDistance);
    const spinDirection = moveDistance / passedDistance;
    columns[pressedColumn].move((event.data.global.y - lastY) / target.worldTransform.d);
    columns[pressedColumn]._direction = spinDirection;
    columns[pressedColumn].addIconIfNeed();
    lastY = event.data.global.y;
    const iconHeight = isMobile() ? 98 : 194;
    // const iconHeight = isMobile() ? 100 : 196;
    if (passedDistance >= iconHeight / 2) {
      // gameEvents.emit('setSwipeDirection', spinDirection);
      // gameEvents.emit('startSpin');
      if (!gameStore.isSpinStart) {
        gameDrawer.updateColumnsDirection(spinDirection);
        gameService.doSpin();
      }
    }
  }
}

function setInteractive(interactive) {
  target.interactive = interactive;
  secondTarget.interactive = interactive;
  target.cursor = interactive ? 'grab' : 'default';
  secondTarget.cursor = interactive ? 'grab' : 'default';
}

export function addTouchControl(iconsContainer, winContainer, reels) {
  columns = reels;
  touchMoving = false;
  touchY = 0;
  moveDistance = 0;
  returnControl = null;
  iconsContainer.on('pointerdown', onTouchStart);
  winContainer.on('pointerdown', onTouchStart);
  iconsContainer.on('pointerup', returnToThePlace);
  iconsContainer.on('pointerupoutside', returnToThePlace);
  iconsContainer.on('pointermove', onPointerMove);
  iconsContainer.on('pointerout', returnToThePlace);
  target = iconsContainer;
  secondTarget = winContainer;
  pressedColumn = -1;
  setInteractive(true);
}
